// extracted by mini-css-extract-plugin
export var scrollArea = "_po-0";